<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.18371 9.07447C5.74192 9.52795 4.69629 10.8752 4.69629 12.4666V17.8144C4.69629 19.7779 6.28804 21.3696 8.25155 21.3696C10.4567 21.3696 13.5314 21.3696 15.7365 21.3696C17.7 21.3696 19.2918 19.7779 19.2918 17.8144V12.4666C19.2918 10.8752 18.2462 9.52795 16.8044 9.07447V7.44566C16.8044 4.789 14.6507 2.63535 11.9941 2.63535C9.33737 2.63535 7.18371 4.789 7.18371 7.44566V9.07447ZM17.7071 12.4666V17.8144C17.7071 18.9028 16.8249 19.785 15.7365 19.785H8.25155C7.16321 19.785 6.28094 18.9028 6.28094 17.8144V12.4666C6.28094 11.3782 7.16321 10.496 8.25155 10.496H15.7365C16.8249 10.496 17.7071 11.3782 17.7071 12.4666ZM11.2017 14.2397V16.0412C11.2017 16.4785 11.5567 16.8335 11.9941 16.8335C12.4313 16.8335 12.7863 16.4785 12.7863 16.0412V14.2397C12.7863 13.8024 12.4313 13.4474 11.9941 13.4474C11.5567 13.4474 11.2017 13.8024 11.2017 14.2397ZM15.2197 7.44566V8.91123H8.76837V7.44566C8.76837 5.66418 10.2125 4.22001 11.9941 4.22001C13.7756 4.22001 15.2197 5.66418 15.2197 7.44566Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Lock'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
